import { Button } from "design-system/atoms/Button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "design-system/atoms/Dialog"
import { useTranslation } from "react-i18next"

type Props = {
  kind: "success" | "cancel"
  onClose: () => void
}

export function CheckoutDialog({ kind, onClose }: Props) {
  const { t } = useTranslation()

  switch (kind) {
    case "success":
      return (
        <Dialog open onOpenChange={onClose}>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>{t("subscription.checkout.success.title")}</DialogTitle>
              <DialogDescription>
                {t("subscription.checkout.success.description")}
              </DialogDescription>
            </DialogHeader>
            <DialogFooter>
              <Button variant="outline" onClick={onClose}>
                {t("shared.close")}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )

    case "cancel":
      return (
        <Dialog open onOpenChange={onClose}>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>{t("subscription.checkout.cancel.title")}</DialogTitle>
              <DialogDescription>{t("subscription.checkout.cancel.description")}</DialogDescription>
            </DialogHeader>
            <DialogFooter>
              <Button variant="outline" onClick={onClose}>
                {t("shared.close")}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )
  }
}
